export default __webpack_public_path__ + "static/media/walad.9f1e68de.png";